import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { DeleteRelationshipNoteResponse, } from "../types";
export const url = (advisorId, noteId) => {
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/advisor/${advisorId}/notes/${noteId}`
        : `https://middleware.uat.farther.com/entity/advisor/${advisorId}/notes/${noteId}`;
};
export const deleteRelationshipNote = async (advisorId, noteId, idempotencyKey, config) => {
    const resp = await axios.delete(url(advisorId, noteId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            version: "20250619",
            "Idempotency-key": idempotencyKey,
        },
        validateStatus: () => true,
    });
    if (resp.status >= 300) {
        const body = resp.data;
        throw new Error(`Error ${resp.status} for ${url(advisorId, noteId)}, ${JSON.stringify(body)}`);
    }
    const decoded = DeleteRelationshipNoteResponse.safeParse(resp.data);
    if (decoded.success) {
        return decoded.data.data.deletedNote;
    }
    else {
        const errorMessage = "[deleteRelationshipNote] returned unexpected data.";
        errorLog(deleteRelationshipNote.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=deleteRelationshipNote.js.map